import { WarningAlert } from '@/components';
import { TRADE } from '@/utils/strings';
const WalletFoundButNoAssetsFoundToSellWarningAlert = () => (
  <WarningAlert
    title={TRADE.WALLET_FOUND_BUT_NO_ASSETS_FOUND_TITLE}
    description={TRADE.WALLET_FOUND_BUT_NO_ASSETS_FOUND_DESCRIPTION}
  />
);
export default WalletFoundButNoAssetsFoundToSellWarningAlert;
